import React from "react";
import PropTypes from "prop-types";
import TextInfo from "@/bit/components/components.text";
import IconGlyph from "@/bit/components/components.icon-glyph";
import CharacteristicItem from "../cms-characteristic-item";
import emptyContent from "./emptyContent.json";
import { getLayoutClassName, getContainerClassName } from "./utils";

/**
 * Componente que permite crear un Listado de características
 */
function CmsCharacteristicList(props) {
  const {
    blockName,
    alias,
    columns,
    className,
    cmsHandler,
    layout = "default",
    listIndex = 1,
    CmsAddElement,
    CmsEditableGroupIcons,
  } = props;
  const wrapElementsOnDivs = props?.wrapElementsOnDivs || cmsHandler || false;
  const title = props["cms-atom-text-1"];
  const list = props["cms-ml-single-characteristic-list"] || [];

  // Add Element Props
  const addProps = {
    contentId: blockName,
    itemIdDotNotation: `${blockName}${blockName?.includes("product-info") ? `.cms-ml-characteristics-${listIndex}` : ""}.cms-ml-single-characteristic-list`,
    layout: layout === "default" ? "vertical" : "horizontal",
    small: layout === "default",
  };

  const finalColumns = parseInt(columns) || 5;

  // Cuando no hay elementos en el editor
  if (process.env.NEXT_PUBLIC_ASTRO_MAKER && list?.length === 0) {
    list.push(emptyContent);
  }

  const createCharacItem = (listToRender) => {
    return listToRender.map((itemProps, index) => (
      <CharacteristicItem
        key={`charac-${index}`}
        {...itemProps}
        layout={layout}
        cmsHandler={cmsHandler}
        alias={alias}
        blockName={blockName}
        listIndex={listIndex}
        index={index}
        frontalListToDelete={listToRender}
        CmsEditableGroupIcons={CmsEditableGroupIcons}
      />
    ));
  };

  if (wrapElementsOnDivs) {
    return (
      <>
        <div
          id={blockName || ""}
          className={`${getContainerClassName(
            layout,
            "cms-characteristics-item",
            blockName,
          )}`}
        >
          {cmsHandler && (
            <span
              className={
                "element-editable block edit-component cms-characteristics-placeholder"
              }
              onClick={() =>
                cmsHandler({
                  ...props,
                  name: "cms-block.cms-characteristic-list",
                })
              }
            >
              <IconGlyph id="lapiz-m" height={20} color="white" />
            </span>
          )}

          <div className="cms-title-characteristics">
            {title && <TextInfo {...title} cmsHandler={cmsHandler} />}
          </div>
          <div
            className={`${getLayoutClassName(
              layout,
              "cms-characteristics-list",
            )}`}
            style={{ gridTemplateColumns: `repeat(${finalColumns}, 1fr)` }}
          >
            {CmsAddElement && (
              <CmsAddElement
                addProps={{
                  index: "start",
                  ...addProps,
                }}
                cmsHandler={cmsHandler}
              />
            )}
            {list &&
              Array.isArray(list) &&
              list.length > 0 &&
              createCharacItem(list)}
            {CmsAddElement && (
              <CmsAddElement
                addProps={{
                  index: "end",
                  ...addProps,
                }}
                cmsHandler={cmsHandler}
              />
            )}
          </div>
        </div>
        <style jsx>{`.cms-characteristics-item {
  background-color: white;
  position: relative;
  &-grid {
    margin: 2rem 0;
  }
  .cms-title-characteristics {
    margin-bottom: 1rem;
  }
  .cms-characteristics-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    
    &-grid {
      display: grid;
      justify-content: space-between;
      gap: 4rem;
      row-gap: 3rem;
    }
  }
}

@media screen and (max-width: 992px) {
  .cms-characteristics-item {
    .cms-characteristics-list {
      &-grid {
        gap: 1rem;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .cms-characteristics-item {
    .cms-characteristics-list {
      &-grid {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-around;
      }
    }
  }
}
`}</style>
      </>
    );
  }
  /*
   render para invocar desde el cms-module-characteristics-and-steps o antiguo fibre-pros-section
    permite que se queden elementos suelos para que un grid superior lso alinee
  */
  return (
    <>
      {title && (
        <TextInfo {...title} cmsHandler={cmsHandler} className={className} />
      )}
      {createCharacItem(list)}
    </>
  );
}

export default CmsCharacteristicList;

CmsCharacteristicList.propTypes = {
  /**
   * {
   *  "info": "Layour del componente. Controla la distribución de los elementos.",
   *  "kind": "both",
   *  "beautifulName": "Layout",
   *  "values": "./enums.js:LAYOUT_TYPES"
   * }
   */
  layout: PropTypes.oneOf(["default", "grid"]),
  /**
   * {
   *  "info": "Permite que se queden elementos sueltos para que un grid superior los alinee cuando es false",
   *  "kind": "dev",
   *  "beautifulName": "wrapElementsOnDivs"
   * }
   */
  wrapElementsOnDivs: PropTypes.bool,
  /**
   * {
   *  "info": "Si no es nulo, obliga al grid a tener unas columnas especificas",
   *  "kind": "both",
   *  "beautifulName": "Número de columnas (0 si no se quiere especificar)"
   * }
   */
  columns: PropTypes.number,
};

CmsCharacteristicList.defaultProps = {
  layout: "default",
  wrapElementsOnDivs: true,
  columns: 0,
};
